module.exports = __webpack_public_path__ + "static/media/c6bannerModulE_small.b8e99988.jpg";